/* Navegación Calm v4 · Calm Colombia (31 oct 2026). Abre el menú del celular, el panel de colchones y la búsqueda rápida
   en lugar de las piezas de la plantilla. Si este archivo no carga, la plantilla sigue funcionando como antes. */
(function () {
  var root = document.querySelector('[data-cnav]');
  if (!root) return;
  var html = document.documentElement;
  var ON_M = root.getAttribute('data-movil') === 'true';
  var ON_E = root.getAttribute('data-escritorio') === 'true';
  var ON_S = root.getAttribute('data-busqueda') === 'true';
  var drawer = root.querySelector('[data-cnav-drawer]');
  var mega = root.querySelector('[data-cnav-mega]');
  var search = root.querySelector('[data-cnav-search]');
  var input = root.querySelector('[data-cnav-q]');
  var res = root.querySelector('[data-cnav-res]');
  var vacio = root.querySelector('[data-cnav-vacio]');
  var abierto = null, conHistoria = false;

  function dl(o) { try { (window.dataLayer = window.dataLayer || []).push(o); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function pesos(n) { n = Math.round(Number(n) || 0); return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function img(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  if (ON_E) html.classList.add('cnav-on');

  /* Abrir y cerrar */
  function abrir(el) {
    if (abierto && abierto !== el) cerrar(true);
    el.hidden = false;
    abierto = el;
    if (el !== mega) {
      html.classList.add('cnav-lock');
      try { history.pushState({ cnav: 1 }, ''); conHistoria = true; } catch (e) { conHistoria = false; }
    }
  }
  function cerrar(sinHistoria) {
    if (!abierto) return;
    var el = abierto;
    el.hidden = true;
    abierto = null;
    if (el !== mega) {
      html.classList.remove('cnav-lock');
      if (!sinHistoria && conHistoria && history.state && history.state.cnav) { conHistoria = false; history.back(); }
      conHistoria = false;
    }
  }
  window.addEventListener('popstate', function () { if (abierto && abierto !== mega) { conHistoria = false; cerrar(true); } });
  window.addEventListener('pageshow', function (e) { if (e.persisted && abierto) { conHistoria = false; cerrar(true); } });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && abierto) cerrar(); });

  function abrirBusqueda(origen) {
    if (abierto === drawer) { drawer.hidden = true; search.hidden = false; abierto = search; }
    else abrir(search);
    input.value = '';
    ultimo = '';
    pintarVacio();
    input.focus();
    dl({ event: 'menu_clic', menu_zona: 'buscar', menu_destino: origen || 'lupa', menu_tipo: origen === 'menu' ? 'movil' : 'busqueda' });
  }

  /* Clics de la plantilla: se interceptan antes de que la plantilla los reciba */
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || root.contains(t)) return;
    if (ON_M && t.closest('.m-menu-button')) {
      e.preventDefault(); e.stopImmediatePropagation();
      abrir(drawer);
      var sc = drawer.querySelector('.cnav-d__in'); if (sc) sc.scrollTop = 0;
      dl({ event: 'menu_clic', menu_zona: 'abrir', menu_destino: 'menu', menu_tipo: 'movil' });
      return;
    }
    if (ON_S && t.closest('m-search-popup, [data-open-search-popup]')) {
      e.preventDefault(); e.stopImmediatePropagation();
      abrirBusqueda('lupa');
    }
  }, true);

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cnav-cerrar]')) { e.preventDefault(); cerrar(); return; }
    if (t.closest('[data-cnav-abrir-busqueda]')) { e.preventDefault(); abrirBusqueda('menu'); return; }
    if (t === search) { cerrar(); return; }
    var a = t.closest('a[href]');
    if (!a) return;
    var z = a.getAttribute('data-cnav-z') || 'otro';
    var h = (a.getAttribute('href') || '').slice(0, 100);
    if (abierto === search || search.contains(a)) {
      dl({ event: 'busqueda_clic', zona: 'rapida-' + z.replace('rapida-', ''), destino: h, termino: (input.value || '').toLowerCase().slice(0, 60) });
    } else {
      dl({ event: 'menu_clic', menu_zona: z, menu_destino: h, menu_tipo: mega.contains(a) ? 'escritorio' : 'movil' });
    }
  });

  /* Panel de colchones en escritorio */
  if (ON_E) {
    var li = null, tA = null, tC = null;
    document.querySelectorAll('.m-header__desktop li.m-menu__item').forEach(function (l) {
      var a = l.querySelector(':scope > a.m-menu__link');
      if (a && a.getAttribute('href') === '/collections/colchones-calm') li = l;
    });
    function ubicar() {
      var h = document.querySelector('.m-header__wrapper') || (li && li.closest('header'));
      var b = h ? h.getBoundingClientRect().bottom : 64;
      mega.style.setProperty('--cnav-top', Math.max(0, Math.round(b)) + 'px');
    }
    function abrirMega() { clearTimeout(tC); if (abierto === mega) return; tA = setTimeout(function () { if (window.innerWidth < 1000) return; ubicar(); abrir(mega); }, 90); }
    function cerrarMega() { clearTimeout(tA); tC = setTimeout(function () { if (abierto === mega) cerrar(true); }, 180); }
    if (li) {
      li.addEventListener('mouseenter', abrirMega);
      li.addEventListener('mouseleave', cerrarMega);
      li.addEventListener('focusin', abrirMega);
      mega.addEventListener('mouseenter', function () { clearTimeout(tC); });
      mega.addEventListener('mouseleave', cerrarMega);
      mega.addEventListener('focusout', function (e) { if (!mega.contains(e.relatedTarget) && !li.contains(e.relatedTarget)) cerrarMega(); });
      window.addEventListener('scroll', function () { if (abierto === mega) ubicar(); }, { passive: true });
    }
  }

  /* Búsqueda rápida */
  var meta = {};
  root.querySelectorAll('[data-cnav-drawer] .cnav-p').forEach(function (p) {
    var d = p.querySelector('.cnav-p__d'), em = p.querySelector('.cnav-p__t em');
    meta[p.getAttribute('href')] = { d: d ? d.textContent : '', b: em ? em.textContent : '' };
  });
  var wa = root.getAttribute('data-wa');
  var timer = null, timerDl = null, ctrl = null, ultimo = '', enviado = '';

  function pintarVacio() { res.innerHTML = ''; res.appendChild(vacio); vacio.hidden = false; }

  function tarjeta(p) {
    var path = (p.url || '').split('?')[0];
    var m = meta[path] || {};
    var nom = String(p.title || '').split(' | ')[0];
    var pr = Number(p.price_min || p.price), cmp = Number(p.compare_at_price_min || 0);
    var pct = cmp > pr ? Math.floor((cmp - pr) * 100 / cmp) : 0;
    var foto = (p.featured_image && p.featured_image.url) || p.image || '';
    var varia = Number(p.price_max) > Number(p.price_min);
    return '<a class="cnav-c" href="' + esc(p.url) + '" data-cnav-z="producto"><span class="cnav-c__ph">' + (pct ? '<i>-' + pct + '%</i>' : '') + (foto ? '<img src="' + esc(img(foto, 400)) + '" alt="' + esc(nom) + '" loading="lazy" width="200" height="200">' : '') + '</span><span class="cnav-c__b"><span class="cnav-c__t">' + esc(nom) + '</span><span class="cnav-c__d">' + esc(m.d || '') + '</span><span class="cnav-c__pr">' + (varia ? '<small>Desde</small>' : '') + '<b>' + pesos(pr) + '</b>' + (pct ? '<s>' + pesos(cmp) + '</s>' : '') + '</span></span></a>';
  }

  function pintar(q, R) {
    var prods = R.products || [], cols = R.collections || [], pags = R.pages || [], arts = R.articles || [];
    var n = prods.length + cols.length + pags.length + arts.length;
    var urlTodos = '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    var h = '';
    if (!n) {
      h += '<div class="cnav-no"><b>No encontramos “' + esc(q) + '”</b><p>Prueba con otra palabra o escríbenos y te ayudamos a elegir.</p></div>';
      h += '<div class="cnav-l" style="margin-top:12px"><a href="/pages/preguntas-frecuentes" data-cnav-z="sin-resultados"><span>Ir al centro de ayuda</span></a><a href="' + esc(wa) + '" target="_blank" rel="noopener" data-cnav-z="whatsapp"><span>Escríbenos por WhatsApp</span></a></div>';
    } else {
      if (prods.length) h += '<div class="cnav-h"><span>Productos</span></div><div class="cnav-g">' + prods.slice(0, 8).map(tarjeta).join('') + '</div>';
      if (cols.length) h += '<div class="cnav-h"><span>Colecciones</span></div><div class="cnav-qk">' + cols.slice(0, 6).map(function (c) { return '<a href="' + esc(c.url) + '" data-cnav-z="coleccion">' + esc(c.title) + '</a>'; }).join('') + '</div>';
      var cont = pags.slice(0, 4).map(function (p) { var faq = /\?/.test(p.title) || /^faq-/.test(p.handle || ''); return { u: p.url, t: p.title, k: faq ? 'Pregunta frecuente' : 'Página' }; })
        .concat(arts.slice(0, 3).map(function (a) { return { u: a.url, t: a.title, k: 'Blog Modo Calm' }; }));
      if (cont.length) h += '<div class="cnav-h"><span>Respuestas y guías</span></div><div class="cnav-l">' + cont.map(function (c) { return '<a href="' + esc(c.u) + '" data-cnav-z="contenido"><span>' + esc(c.t) + '<small>' + c.k + '</small></span></a>'; }).join('') + '</div>';
    }
    h += '<a class="cnav-all" href="' + urlTodos + '" data-cnav-z="todos">Ver todos los resultados de “' + esc(q) + '”</a>';
    vacio.hidden = true;
    res.innerHTML = h;
    res.appendChild(vacio);
    return prods.length + pags.length + arts.length;
  }

  function buscar(q) {
    if (ctrl) try { ctrl.abort(); } catch (e) {}
    ctrl = window.AbortController ? new AbortController() : null;
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product,collection,page,article&resources%5Blimit%5D=8&resources%5Boptions%5D%5Bunavailable_products%5D=last';
    fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (q !== ultimo) return;
        var n = pintar(q, (j.resources && j.resources.results) || {});
        clearTimeout(timerDl);
        timerDl = setTimeout(function () {
          var k = q.toLowerCase();
          if (k.length > 2 && k !== enviado) { enviado = k; dl({ event: 'busqueda_resultados', termino: k.slice(0, 60), resultados: n, zona: 'rapida' }); }
        }, 1200);
      })
      .catch(function () {});
  }

  if (ON_S && input) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      ultimo = q;
      clearTimeout(timer);
      if (q.length < 2) { pintarVacio(); return; }
      timer = setTimeout(function () { buscar(q); }, 220);
    });
    root.querySelector('[data-cnav-form]').addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q) { e.preventDefault(); return; }
      dl({ event: 'busqueda_clic', zona: 'rapida-enter', destino: '/search', termino: q.toLowerCase().slice(0, 60) });
    });
  }
})();
